<div class="p-4">
    <div class="bg-white dark:bg-[#19191c] p-6 rounded shadow-sm mb-6">
        <h3 class="text-lg font-semibold text-gray-800 mb-4">Nueva Documentación de {{ nombre }}</h3>
        <form [formGroup]="form" (ngSubmit)="agregarDocumento()">
            <!-- Sugerencia de pre-llenado desde datos del conductor -->
            @if (mostrarSugerenciaLicencia) {
                <div class="flex items-start gap-3 p-3 mb-4 rounded-lg border border-blue-300 bg-blue-50 dark:bg-blue-900/20 dark:border-blue-700 text-sm">
                    <i class="pi pi-info-circle text-blue-500 text-lg flex-shrink-0 mt-0.5"></i>
                    <span class="text-blue-800 dark:text-blue-200 flex-1">
                        Este conductor tiene una fecha de vencimiento de licencia en sus datos. ¿Querés pre-completar la fecha de vencimiento?
                    </span>
                    <button pButton type="button" label="Sí, completar" class="p-button-sm p-button-info flex-shrink-0" (click)="aplicarDatosLicencia()"></button>
                    <button pButton type="button" icon="pi pi-times" class="p-button-sm p-button-text p-button-secondary flex-shrink-0" (click)="descartarSugerencia()" pTooltip="Descartar"></button>
                </div>
            }

            <div class="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
                <div>
                    <label for="id_tipo" class="block font-semibold mb-2 text-gray-700">Tipo</label>
                    <p-select
                        [showClear]="true"
                        id="id_tipo"
                        formControlName="id_tipo"
                        [options]="tiposDocumento"
                        optionLabel="label"
                        placeholder="Seleccione Tipo"
                        [ngClass]="{ 'p-invalid': form.get('id_tipo')?.invalid && form.get('id_tipo')?.touched }"
                        class="w-full custom-select" />
                    <app-input-error [control]="form.get('id_tipo')"></app-input-error>
                </div>

                <div class="flex flex-col">
                    <label for="fecha_emision" class="block font-semibold mb-2 text-gray-700 dark:text-zinc-400">Fecha
                        de Emisión</label>
                    <p-datepicker id="fecha_emision" formControlName="fecha_emision" dateFormat="dd/mm/yy"
                        appendTo="body" [iconDisplay]="'input'" [showIcon]="true" placeholder="dd/mm/aaaa"
                        [ngClass]="{ 'p-invalid': form.get('fecha_emision')?.invalid && form.get('fecha_emision')?.touched }"
                        class="w-full" [inputStyleClass]="'w-full'">
                    </p-datepicker>
                    <app-input-error [control]="form.get('fecha_emision')"></app-input-error>
                </div>

                <div class="flex flex-col">
                    <label for="fecha_venc" class="block font-semibold mb-2 text-gray-700 dark:text-zinc-400">Fecha de
                        Vencimiento</label>
                    <p-datepicker id="fecha_venc" formControlName="fecha_venc" appendTo="body" [iconDisplay]="'input'"
                        [showIcon]="true" placeholder="dd/mm/aaaa"
                        [ngClass]="{ 'p-invalid': form.get('fecha_venc')?.invalid && form.get('fecha_venc')?.touched }"
                        class="w-full" [inputStyleClass]="'w-full'">
                    </p-datepicker>
                    <app-input-error [control]="form.get('fecha_venc')"></app-input-error>
                </div>

                <div class="flex flex-col lg:col-span-2">
                    <label class="text-sm font-semibold mb-2 text-gray-600 dark:text-zinc-400">
                        Documento Adjunto <span class="font-normal opacity-70">(PDF, JPG, PNG)</span>
                    </label>
                    <div class="flex items-center gap-2">
                        <div class="relative flex-grow">
                            <input type="file" id="adjunto" class="hidden" (change)="onArchivoSeleccionado($event)"
                                #fileInput />
                            <div class="flex border rounded-md overflow-hidden dark:border-zinc-700">
                                <span
                                    class="bg-gray-50 dark:bg-zinc-800 px-4 py-2 text-sm text-gray-500 dark:text-zinc-400 flex-grow truncate">
                                    {{ file ? getNombreArchivo(form.value.archivo) : 'Ningún archivo seleccionado' }}
                                </span>
                                <button type="button"
                                    class="bg-primary-500 hover:bg-primary-700 text-white px-4 py-2 text-sm font-medium transition-colors"
                                    (click)="fileInput.click()">
                                    <i class="pi pi-upload mr-2"></i> Examinar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex justify-end mt-4">
                <button pButton type="submit" label="Agregar Documentación" [disabled]="form.invalid"></button>
            </div>
        </form>
    </div>

    <!-- ── Documentos cargados ─────────────────────────────────── -->
    <div class="mb-2">
        <h4 class="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider px-1 mb-3">Documentos cargados</h4>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">

            <!-- ── Vigente ──────────────────────────────────── -->
            <div class="rounded-xl border-2 border-green-300 dark:border-green-700 bg-green-50/60 dark:bg-green-900/10 flex flex-col overflow-hidden transition-all">
                <div class="flex items-start justify-between px-4 py-3">
                    <div>
                        <p class="font-bold text-green-800 dark:text-green-300 text-sm">Vigente</p>
                        <p class="text-xs text-green-600/70 dark:text-green-500/80 mt-0.5">Documentación al día.</p>
                    </div>
                    <span class="text-xs font-semibold rounded-full px-2.5 py-0.5 ml-2 flex-shrink-0 mt-0.5"
                        [ngClass]="documentosVigentes.length > 0 ? 'bg-green-200 dark:bg-green-800 text-green-800 dark:text-green-200' : 'bg-gray-200 dark:bg-gray-700 text-gray-400'">
                        {{ documentosVigentes.length }} docs
                    </span>
                </div>
                @if (documentosVigentes.length > 0) {
                    <div class="px-3 pb-3 flex flex-col gap-2">
                        @for (doc of documentosVigentes; track doc.id) {
                            <div class="bg-white dark:bg-[#1c1c20] rounded-lg p-3 flex items-start gap-3 border border-green-100 dark:border-green-900/60 shadow-sm">
                                <i class="pi pi-verified text-green-500 text-base mt-0.5 flex-shrink-0"></i>
                                <div class="flex-1 min-w-0">
                                    <p class="font-semibold text-sm text-gray-800 dark:text-gray-100 truncate">{{ getTipo(doc.id_tipo) }}</p>
                                    <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                                        <i class="pi pi-calendar-times text-[9px] mr-0.5"></i>Vence: {{ doc.fecha_venc | date:'dd/MM/yyyy' }}
                                    </p>
                                    @if (doc.usuario_carga) {
                                        <p class="text-xs text-gray-400 dark:text-gray-500 mt-0.5">
                                            <i class="pi pi-user text-[9px] mr-0.5"></i>{{ doc.usuario_carga }}
                                        </p>
                                    }
                                </div>
                                <div class="flex flex-col gap-0.5 flex-shrink-0">
                                    <button pButton icon="pi pi-eye" class="p-button-rounded p-button-text p-button-sm" pTooltip="Ver adjunto" (click)="verAdjunto(doc)"></button>
                                    <button pButton icon="pi pi-trash" class="p-button-rounded p-button-text p-button-danger p-button-sm" pTooltip="Eliminar" (click)="eliminarDocumento(doc, documentosVigentes)"></button>
                                </div>
                            </div>
                        }
                    </div>
                } @else {
                    <div class="px-3 pb-3">
                        <div class="border border-dashed border-green-300 dark:border-green-700/50 rounded-lg py-3 text-center text-xs text-green-600/60 dark:text-green-500/50">
                            Sin documentos vigentes.
                        </div>
                    </div>
                }
            </div>

            <!-- ── Próximo a Vencer ──────────────────────────── -->
            <div class="rounded-xl border-2 border-amber-300 dark:border-amber-700 bg-amber-50/60 dark:bg-amber-900/10 flex flex-col overflow-hidden transition-all">
                <div class="flex items-start justify-between px-4 py-3">
                    <div>
                        <p class="font-bold text-amber-800 dark:text-amber-300 text-sm">Próximo a Vencer</p>
                        <p class="text-xs text-amber-600/70 dark:text-amber-500/80 mt-0.5">Vence en los próximos 3 meses.</p>
                    </div>
                    <span class="text-xs font-semibold rounded-full px-2.5 py-0.5 ml-2 flex-shrink-0 mt-0.5"
                        [ngClass]="documentosProximos.length > 0 ? 'bg-amber-200 dark:bg-amber-800 text-amber-800 dark:text-amber-200' : 'bg-gray-200 dark:bg-gray-700 text-gray-400'">
                        {{ documentosProximos.length }} docs
                    </span>
                </div>
                @if (documentosProximos.length > 0) {
                    <div class="px-3 pb-3 flex flex-col gap-2">
                        @for (doc of documentosProximos; track doc.id) {
                            <div class="bg-white dark:bg-[#1c1c20] rounded-lg p-3 flex items-start gap-3 border border-amber-100 dark:border-amber-900/60 shadow-sm">
                                <i class="pi pi-clock text-amber-500 text-base mt-0.5 flex-shrink-0"></i>
                                <div class="flex-1 min-w-0">
                                    <p class="font-semibold text-sm text-gray-800 dark:text-gray-100 truncate">{{ getTipo(doc.id_tipo) }}</p>
                                    <p class="text-xs text-amber-600 dark:text-amber-400 font-medium mt-0.5">
                                        <i class="pi pi-calendar-times text-[9px] mr-0.5"></i>Vence: {{ doc.fecha_venc | date:'dd/MM/yyyy' }}
                                    </p>
                                    @if (doc.usuario_carga) {
                                        <p class="text-xs text-gray-400 dark:text-gray-500 mt-0.5">
                                            <i class="pi pi-user text-[9px] mr-0.5"></i>{{ doc.usuario_carga }}
                                        </p>
                                    }
                                </div>
                                <div class="flex flex-col gap-0.5 flex-shrink-0">
                                    <button pButton icon="pi pi-eye" class="p-button-rounded p-button-text p-button-sm" pTooltip="Ver adjunto" (click)="verAdjunto(doc)"></button>
                                    <button pButton icon="pi pi-trash" class="p-button-rounded p-button-text p-button-danger p-button-sm" pTooltip="Eliminar" (click)="eliminarDocumento(doc, documentosProximos)"></button>
                                </div>
                            </div>
                        }
                    </div>
                } @else {
                    <div class="px-3 pb-3">
                        <div class="border border-dashed border-amber-300 dark:border-amber-700/50 rounded-lg py-3 text-center text-xs text-amber-600/60 dark:text-amber-500/50">
                            Sin documentos próximos a vencer.
                        </div>
                    </div>
                }
            </div>

            <!-- ── Vencido ───────────────────────────────────── -->
            <div class="rounded-xl border-2 border-red-300 dark:border-red-700 bg-red-50/60 dark:bg-red-900/10 flex flex-col overflow-hidden transition-all">
                <div class="flex items-start justify-between px-4 py-3">
                    <div>
                        <p class="font-bold text-red-800 dark:text-red-300 text-sm">Vencido</p>
                        <p class="text-xs text-red-600/70 dark:text-red-500/80 mt-0.5">Requieren renovación urgente.</p>
                    </div>
                    <span class="text-xs font-semibold rounded-full px-2.5 py-0.5 ml-2 flex-shrink-0 mt-0.5"
                        [ngClass]="documentosVencidos.length > 0 ? 'bg-red-200 dark:bg-red-800 text-red-800 dark:text-red-200' : 'bg-gray-200 dark:bg-gray-700 text-gray-400'">
                        {{ documentosVencidos.length }} docs
                    </span>
                </div>
                @if (documentosVencidos.length > 0) {
                    <div class="px-3 pb-3 flex flex-col gap-2">
                        @for (doc of documentosVencidos; track doc.id) {
                            <div class="bg-white dark:bg-[#1c1c20] rounded-lg p-3 flex items-start gap-3 border border-red-100 dark:border-red-900/60 shadow-sm">
                                <i class="pi pi-times-circle text-red-500 text-base mt-0.5 flex-shrink-0"></i>
                                <div class="flex-1 min-w-0">
                                    <p class="font-semibold text-sm text-gray-800 dark:text-gray-100 truncate">{{ getTipo(doc.id_tipo) }}</p>
                                    <p class="text-xs text-red-500 dark:text-red-400 font-medium mt-0.5">
                                        <i class="pi pi-calendar-times text-[9px] mr-0.5"></i>Venció: {{ doc.fecha_venc | date:'dd/MM/yyyy' }}
                                    </p>
                                    @if (doc.usuario_carga) {
                                        <p class="text-xs text-gray-400 dark:text-gray-500 mt-0.5">
                                            <i class="pi pi-user text-[9px] mr-0.5"></i>{{ doc.usuario_carga }}
                                        </p>
                                    }
                                </div>
                                <div class="flex flex-col gap-0.5 flex-shrink-0">
                                    <button pButton icon="pi pi-eye" class="p-button-rounded p-button-text p-button-sm" pTooltip="Ver adjunto" (click)="verAdjunto(doc)"></button>
                                    <button pButton icon="pi pi-trash" class="p-button-rounded p-button-text p-button-danger p-button-sm" pTooltip="Eliminar" (click)="eliminarDocumento(doc, documentosVencidos)"></button>
                                </div>
                            </div>
                        }
                    </div>
                } @else {
                    <div class="px-3 pb-3">
                        <div class="border border-dashed border-red-300 dark:border-red-700/50 rounded-lg py-3 text-center text-xs text-red-600/60 dark:text-red-500/50">
                            Sin documentos vencidos.
                        </div>
                    </div>
                }
            </div>

        </div>
    </div>

    <div class="flex justify-end mt-6">
        <button pButton type="button" label="Cerrar" class="p-button-secondary" (click)="cerrar()"></button>
    </div>

    <!-- ── Confirmación desactivar documento ───────────────────── -->
    <p-confirmdialog key="confirmEliminarDoc">
        <ng-template pTemplate="message" let-message>
            <div class="flex flex-col items-center gap-3 py-2 px-2 text-center">
                <i class="pi pi-exclamation-triangle text-4xl text-amber-400"></i>
                <span class="font-semibold text-gray-800 dark:text-gray-100" [innerHTML]="message.message"></span>
            </div>
        </ng-template>
    </p-confirmdialog>

    <!-- ── Mini-modal preview adjunto ───────────────────────────── -->
    @if (adjuntoPreview) {
        <div
            class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm"
            (click)="cerrarPreview()"
        >
            <div
                class="relative bg-white dark:bg-[#19191c] rounded-2xl shadow-2xl w-full max-w-3xl mx-4 flex flex-col overflow-hidden"
                style="max-height: 88vh"
                (click)="$event.stopPropagation()"
            >
                <!-- Header -->
                <div class="flex items-center gap-3 px-5 py-4 border-b border-gray-200 dark:border-gray-700 flex-shrink-0">
                    <i class="pi pi-file text-gray-500 text-lg"></i>
                    <span class="font-semibold text-gray-800 dark:text-gray-100 flex-1 truncate">{{ adjuntoPreview.nombre }}</span>
                    <button
                        pButton
                        icon="pi pi-times"
                        class="p-button-rounded p-button-text p-button-secondary p-button-sm"
                        (click)="cerrarPreview()"
                    ></button>
                </div>

                <!-- Contenido -->
                <div class="flex-1 overflow-auto bg-gray-100 dark:bg-[#111] flex items-center justify-center p-4">
                    @if (adjuntoPreview.isPdf) {
                        <iframe
                            [src]="adjuntoPreview.safeUrl"
                            class="w-full rounded border-0"
                            style="height: 65vh"
                        ></iframe>
                    } @else {
                        <img
                            [src]="adjuntoPreview.url"
                            class="max-w-full max-h-[65vh] object-contain rounded-lg shadow"
                            alt="Adjunto del documento"
                        />
                    }
                </div>

                <!-- Footer -->
                <div class="flex items-center justify-end gap-2 px-5 py-3 border-t border-gray-200 dark:border-gray-700 flex-shrink-0">
                    <a
                        [href]="adjuntoPreview.url"
                        target="_blank"
                        rel="noopener"
                        pButton
                        icon="pi pi-external-link"
                        label="Abrir en nueva pestaña"
                        class="p-button-outlined p-button-sm p-button-secondary"
                    ></a>
                    <button pButton label="Cerrar" class="p-button-sm p-button-secondary" (click)="cerrarPreview()"></button>
                </div>
            </div>
        </div>
    }
</div>